<template>
  <div class="version flex-col page text-df text-black">
    <div class="traffic padding-top-xs" v-if="sata">
      <div class="traddic-box padding-lr-lg padding-tb-sm">
        <div class="text-lg text-500 margin-bottom-sm">存储空间</div>
        <div class="text-gray margin-bottom-sm">活动及投稿作品上传会占用存储空间</div>
        <el-progress color="#3DC4A7" :show-text="false" :text-inside="true" :stroke-width="6"
          :percentage="((sata.userStorageData.usedStorage / 1) / sata.userStorageData.totalStorage) * 100"></el-progress>
        <div class="flex align-center justify-between margin-top-sm">
          已使用 {{ sizeG(sata.userStorageData.usedStorage / 1, 'G') }} / 总量 {{ sizeG(sata.userStorageData.totalStorage, 'G') }}

        </div>
      </div>
      <div class="goods-view">
        <div class="bg-white radius-10 padding-lr-sm padding-top-sm padding-bottom">
          <div class="goods-view-title">购买账号</div>
          <div class="flex align-center justify-between text-500 text-lg"
            style="color:#8B5A13;width:calc(100% - 120px);">
            <div class="flex align-center justify-start" style="width: 100%;">
              <img class="avatar" :src="userinfo.avatar"></img>
              <div class="margin-left-lg" style="width: calc(100% - 60px);">{{ userinfo.userName }}</div>
            </div>
            <bottomModal ref="discountbottomModal">
              <div class="flex align-center justify-start">
                <div class="text-df">{{ VERSIONS[userinfo.vipType].versionName }}</div>
                <div class="discount margin-left-sm" v-if="userinfo.vipType > 0">
                  {{ discount(VERSIONS[userinfo.vipType].discount) }}折</div>
              </div>
              <div slot="part">
                <div class="padding-sm">
                  <div class="text-40 text-500">优惠折扣</div>
                  <div class="margin-top-xxl text-lg">
                    不同的版本购买资源包享受不同的优惠折扣，版本越高折扣越高。
                  </div>
                  <div class="margin-top-xxl notice-new">优惠折扣详解</div>
                  <div class="padding-lg bg-gray margin-top radius-10">
                    <div v-for="item in VERSIONS" v-if="item.versionType != 1">
                      {{ item.versionName }}——{{ (item.versionType == 0 ? '无折扣' : (discount(item.discount) + '折')) }}</div>
                  </div>
                </div>
              </div>
            </bottomModal>
          </div>
        </div>
        <div class="bg-white radius-10 padding-lr-sm margin-top-sm padding-top-sm">
          <div class="notice-tips text-cut"
            v-if="(sata.userStorageData.totalStorage / 1 - sata.userStorageData.usedStorage / 1) < 0">当前剩余存储空间为<span
              style="color: #E0605A;">{{ sizeG(sata.userStorageData.totalStorage / 1 - sata.userStorageData.usedStorage / 1, 'G') }}</span>，建议购买大于{{ sizeG(sata.userStorageData.totalStorage / 1 - sata.userStorageData.usedStorage / 1, 'G') }}
          </div>
          <div class="goods-view-title">有效期</div>
          <div class="margin-top-sm flex align-center justify-start">
            <div class="youxiaoqi w70" :class="chooseDuration == 3 ? 'active' : ''" @click="chooseGoodType(3)">3个月</div>
            <div class="youxiaoqi w70 margin-left" :class="chooseDuration == 12 ? 'active' : ''" @click="chooseGoodType(12)">
              1年</div>
              <div class="youxiaoqi w70 margin-left" :class="chooseDuration == 24 ? 'active' : ''" @click="chooseGoodType(24)">
              2年</div>
              <div class="youxiaoqi w70 margin-left" :class="chooseDuration == 36 ? 'active' : ''" @click="chooseGoodType(36)">
              3年</div>
          </div>
          <div class="goods-view-title margin-top-sm">规格与价格</div>
          <div class="grid col-2 margin-top-sm">
            <div class="good-item-view" v-for="(item, idx) in goods" v-if="chooseDuration == item.duration">
              <div class="good-item" @click="chooseGood(idx)" :class="idx == chooseGoodIdx ? 'active' : ''">
                <div class="good-item-discount" v-if="item.amount / 1 < item.originAmount / 1">
                  已优惠{{ (item.originAmount - item.amount) / 100 }}元</div>
                <div class="good-item-name text-lg text-600 margin-top-xxl text-cut" style="width: 95%;">{{ item.name }}
                </div>
                <div class="good-item-price flex align-end justify-start margin-top-sm">
                  <div>￥</div>
                  <div class="text-xxl text-500 margin-left-xs">{{ item.amount / 100 }}</div>
                  <div class="text-del text-gray margin-left-xs" v-if="item.amount / 1 < item.originAmount / 1">
                    {{ item.originAmount / 100 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white radius-10 padding-lr-sm margin-top-sm padding-tb-sm" @click="discountbottomModal">
          <div class="goods-view-title">优惠折扣</div>
          <div class="flex align-center justify-start margin-top-sm" style="color: #9F7438;" v-if="userinfo.vipType > 0">
            当前版本为{{ VERSIONS[userinfo.vipType].versionName }}：享{{ discount(VERSIONS[userinfo.vipType].discount) }}折优惠
            <div class="discount margin-left-sm">{{ discount(VERSIONS[userinfo.vipType].discount) }}折</div>
          </div>
          <div class="flex align-center justify-start margin-top-sm" style="color: #9F7438;" v-else="">
            当前版本为{{ VERSIONS[userinfo.vipType].versionName }}：无折扣
          </div>
        </div>
        <div class="bg-white radius-10 padding-lr-sm margin-top-sm">
          <div class="solid-bottom padding-tb-lg flex align-center justify-between">
            生效时间
            <div>立即生效<span class="cuIcon-right-margin-left-sm"></span></div>
          </div>
          <div class="solid-bottom padding-tb-sm flex align-center justify-between">
            购买数量
            <div class="flex align-center justify-center"
              style="width: 73px;height: 40px;background: #FFFFFF;border: 1px solid #D2D2D2;border-radius: 8px;">
              {{ count }}</div>
          </div>
          <div class="solid-bottom padding-tb-lg flex align-center justify-between">
            可用区域
            <div>中国大陆<span class="cuIcon-right-margin-left-sm"></span></div>
          </div>
        </div>
      </div>
      <div class="buy-box flex flex-direction align-center justify-start">
        <div style="width: 335px;">100G大约可存储：2万张图片，500 个视频，设置压缩上传可存储更多。</div>
        <div class="flex align-center justify-between buy-box-button" v-if="price">
          <bottomModal cla="rightXClose full auto-height bg-f5f5f5" ref="priceDetail">
            <div class="flex align-center justify-start text-white">
              ￥
              <div class="text-600" style="font-size: 24px;">{{ price.currentAmount / 100 }}</div>
              <div class="buy-box-sub margin-left-sm">共减￥{{ (price.originAmount - price.currentAmount) / 100 }}</div>
            </div>
            <div slot="part" class="padding-top-xl text-lg">
              <div class="text-600 text-center" style="font-size: 16px">金额明细</div>
              <div class="margin-lr-sm bg-white radius margin-top-lg padding-lr-sm padding-top-lg padding-bottom-xl">
                <div>
                  <div class="flex align-center justify-between">
                    <div>订单原价</div>
                    <div>¥{{ price.originAmount / 100 }}</div>
                  </div>
                  <template v-for="dl in price.discountList">
                    <div class="flex align-center justify-between margin-top-lg" v-if="dl.discountType == '折扣'">
                      <div>{{ dl.discount == 1 ? '免费版无折扣' : ('会员折扣' + discount(dl.discount) + '折') }}</div>
                      <div class="text-red">-¥{{ dl.amount / 100 }}</div>
                    </div>
                    <div class="flex align-center justify-between margin-top-lg" v-else="">
                      <div>{{ dl.discountType }}</div>
                      <div class="text-red">-¥{{ dl.amount / 100 }}</div>
                    </div>
                  </template>
                </div>
                <div class="flex align-center justify-end" style="margin-top: 70px;">
                  <div class="text-df text-500">共减</div>
                  <div class="text-red margin-left-sm" style="font-size: 18px;">-¥{{ (price.discountAmount) / 100 }}</div>
                </div>
              </div>
              <div class="overbox padding-top-lg">
                <div class="overbox-but" @click="priceDetailHide">确定</div>
              </div>
            </div>
          </bottomModal>
          <requestPayment @event="requestPaymentEvent" wxpayAct="buy-storage" :amount="price.currentAmount"
            :serviceKey="curGood.serviceKey" :userId="userinfo.id">
            <div class="flex align-center justify-center buy-box-button-buy">
              购买
            </div>
          </requestPayment>
        </div>
        <router-link to="/document/服务购买协议" class="text-black">
          <div class="margin-top-sm">购买即表示同意《<span class="text-blue">服务购买协议</span>》</div>
        </router-link>
      </div>
    </div>
    <serviceDialog ref="serviceDialog"></serviceDialog>
    <div v-if="hasManager" class="openMember-view flex align-center justify-center">
      <el-select v-model="paymentMethod" placeholder="请选择支付方式" style="width: 140px;">
        <el-option v-for="item in paymentMethods" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div @click="managerBuystorage"
        class="flex-col justify-center items-center openMember-button text-wrapper margin-left-sm">
        <span class="text-df text-white">运营已收款<br />立即开通</span>
      </div>
    </div>
    <payedDialog ref="payedDialog" @event="requestPaymentEvent"></payedDialog>
    <serviceFixed></serviceFixed>
  </div>
</template>

<script>
import App from '../util/comfun'
import bottomModal from '../components/common/bottom-modal.vue'
import serviceDialog from '../components/service-dialog.vue'
import requestPayment from '../components/requestPayment.vue'
import payedDialog from '../components/payed-dialog.vue'
import serviceFixed from '../components/service-fixed.vue'
import VConsole from 'vconsole';
export default {
  components: {
    bottomModal,
    serviceDialog,
    requestPayment,
    payedDialog,
    serviceFixed,
  },
  props: {},
  data() {
    return {
      paymentMethods: [
        { value: '1', label: '1: 客户支付' },
        { value: '2', label: '2: 运营收款' },
        { value: '3', label: '3: 对公转账' },
        { value: '4', label: '4.推广赠送' },
      ],
      paymentMethod: '',
      hasManager: false,
      userinfo: {},
      VERSIONS: {},
      hasUsePayBut: false,
      hasInBusiness: 0,
      sata: null,

      chooseGoodIdx: '',
      goods: [],
      count: 1,
      price: null,//金额对象
      curGood: null,//选中的商品

      chooseDuration: 12,//默认选中3个月
    };
  },

  methods: {
    sizeG: App.sizeG,
    discount(discount) {
      if (!discount) return ''
      return ((discount * 10) + '').replace(/\./g, '')
    },
    discountbottomModal() {
      this.$refs.discountbottomModal.show()
    },
    priceDetailHide() {
      this.$refs.priceDetail.hide()
    },
    managerBuystorage() {
      if (this.openMembering) return
      if (this.paymentMethod < 1) return this.$message({ message: '请选择支付方式', type: "fail" });
      this.openMembering = true
      this.loading = this.$loading({ text: '处理中...', target: 'body' })
      App.demand('/admin/user/storageAddToUser', 'POST', {
        "count": this.count,
        "paymentMethod": this.paymentMethod,
        "serviceKey": this.curGood.serviceKey,
        "userId": this.userinfo.id,
      }).then(res => {
        this.openMembering = false
        this.loading.close()
        if (res.code == 200) {
          this.requestPaymentEvent({ payed: true });
        } else {
          this.$message({ message: res.message, type: "fail" });
        }
      })
    },

    isManager() {
      App.demand('user/isManager/current', 'GET').then(res => {
        this.hasManager = res.data.isManager === true
        //this.getUserInfo()
        this.hasUsePayBut = this.usePayBut()
      })
    },
    async getUserInfo() {
      if (!this.options.uid && !this.options.userId) {
        let userx = (await App.demand('/user/detail/current', 'GET')).data
        this.options.uid = userx.id
        this.options.userId = userx.id
      }
      let userinfo = (await App.demand('/user/info', 'GET', {
        userId: this.options.uid || this.options.userId,
      })).data
      let resetRightsDay = (userinfo.resetRightsDay || '').match(/([\d]{4})([\d]{2})([\d]{2})/)
      this.userinfo = {
        userName: userinfo.userName,
        avatar: userinfo.avatar,
        id: userinfo.id,
        vipType: userinfo.vipType,
        endTime: userinfo.endTime,
        resetRightsDay: resetRightsDay,
      }
      if ('1405204833102812013' == this.userinfo.id) {
        const vConsole = new VConsole();
      }
      App.demand('/user/traffic/info', 'GET', {
        userId: this.options.uid || this.options.userId
      }).then(res => {
        let sata = res.data
        sata.updateTime = App.unixtoTime(sata.updateTime, 'YYYY/MM/DD HH:II')
        sata.startDate = sata.startDate.replace(/([\d]{4})([\d]{2})([\d]{2})/, function ($0, y, m, d) {
          return `${y}.${m}.${d}`
        })
        sata.endDate = sata.endDate.replace(/([\d]{4})([\d]{2})([\d]{2})/, function ($0, y, m, d) {
          return `${y}.${m}.${d}`
        })
        this.sata = sata
      })
    },
    async getVersion() {
      let vds = (await App.demand('/activity/version/loadConfigList', 'GET')).data;
      let vers = {};
      vds.forEach(ver => {
        vers[ver.versionType] = ver
      });
      this.VERSIONS = vers
      ////////
      //discount 折扣字段
    },
    unixtoTime: App.unixtoTime,
    serviceDialogShow() {
      this.$refs.serviceDialog.show()
    },
    usePayBut() {
      let hasiPhone = window.navigator.userAgent.toLocaleLowerCase().indexOf('iphone') > -1
      if (this.options.from == 'wxlite' && hasiPhone) {
        //return this.hasManager
        return false
      }
      return true
    },
    gotoVip() {
      let hasDebug = location.href.indexOf('--DEBUG--') > -1
      let path = App.http_build_query({
        'version': encodeURIComponent(JSON.stringify(this.options))
      }, '/', true)
      path = path.replace('/#/', '/')
      console.error(path)
      this.$router.push(path)
    },
    async queryPayServiceItemList() {
      let res = await App.demand('/activity/payment/queryPayServiceItemList', 'POST', {
        pageIndex: 1,
        pageSize: 100,
        paymentType: 'storage',
        //versionType:this.selected,
      })
      this.goods = res.data.list || null
    },
    async chooseGood(idx) {
      this.chooseGoodIdx = idx
      if (!this.goods || this.goods.length < 1) {
        await this.queryPayServiceItemList()
      }
      this.curGood = this.goods[this.chooseGoodIdx]
      this.queryCdnTrafficAmount()
    },
    queryCdnTrafficAmount() {
      App.demand('/activity/payment/queryStorageAmount', 'POST', {
        //"activityId": 0,
        "count": this.count,
        "serviceKey": this.goods[this.chooseGoodIdx].serviceKey,
        //"tradeType": 0,
        "userId": this.userinfo.id || this.options.uid,
      }).then(res => {
        this.price = res.data
        this.price.originAmount = this.goods[this.chooseGoodIdx].originAmount
        //增加上立减
        /*
        let lijian=this.goods[this.chooseGoodIdx].originAmount-this.goods[this.chooseGoodIdx].amount
        this.price.discountList.unshift({
          amount: lijian,
          discount: 1,
          discountType: "立减",
          remark: "立减",
        })
        this.price.discountAmount=this.price.discountAmount/1+lijian
        */
        if (this.loading) this.loading.close()
      })
    },
    requestPaymentEvent(e) {
      console.log('requestPaymentEvent', e)
      if (e.act == 'reFlush') {
        return this.getUserInfo()
      }
      if (e.act == 'services') {
        return this.serviceDialogShow()
      }
      if (e.payed) {
        this.$refs.payedDialog.show({ desc: '你已成功购买云流量' })
      }
    },
    chooseGoodType(type) {
      let dfIdxs={
        3:1,
        12:7,
        24:13,
        36:19,
      }
      this.chooseDuration = type
      this.chooseGoodIdx = dfIdxs[type]//type == 3 ? 1 : 7
      this.curGood = this.goods[this.chooseGoodIdx]
      this.queryCdnTrafficAmount()
    },
    async initMounted() {
      this.loading = this.$loading({
        lock: true,
        text: '正在加载',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let hasLogined = false
      if (this.$route.params.options) {
        try {
          this.options = JSON.parse(decodeURIComponent(this.$route.params.options))
          hasLogined = true
          this.hasInBusiness = this.options.hasInBusiness
          if (this.hasInBusiness == 1) {

          }
        } catch (e) { }
      }
      console.info('hasLogined', hasLogined, this.options)
      if (!hasLogined || !this.options || typeof this.options != 'object') { return App.wxLogin() }
      if (this.options.hasPayed == 1) {
        this.$refs.payedDialog.show({ desc: '你已成功购买云流量' })
      }
      this.getVersion()
      console.log('options', this.options)
      wxlite.setStorageSync('token', this.options.token)
      this.isManager()
      await this.getUserInfo()
      this.chooseGood(7)
      document.querySelector('body').setAttribute('style', 'background-color:#EBEBEB;')
    },
  },
  /**
   * from,token,userId
   */
  mounted() {
    this.initMounted()
  },
};
</script>

<style scoped lang="css">
@import "../../static/icon.css";
@import "../../static/buy-x.css";
</style>



// WEBPACK FOOTER //
// src/pages/buy-storage.vue